/**
 * Professional Gradient Mesh Paint Worklet
 * 
 * Creates high-end organic color blending using a multi-point mesh interpolation.
 * Replicates the look of professional design tools like Adobe Illustrator or Figma plugins.
 */

class GradientMesh {
  static get inputProperties() {
    return [
      '--fluent-mesh-colors', // Comma separated colors
      '--fluent-mesh-seed',
      '--fluent-mesh-speed'
    ];
  }

  paint(ctx: CanvasRenderingContext2D, size: { width: number; height: number }, props: any) {
    const colorStr = props.get('--fluent-mesh-colors').toString() || '#0078d4, #50e6ff, #00188f';
    const colors = colorStr.split(',').map((c: string) => c.trim());
    const seed = parseFloat(props.get('--fluent-mesh-seed')) || 1;
    
    ctx.save();
    
    // Draw base mesh points and interpolate
    // Simplified for performance: use multiple overlapping radial gradients
    for (let i = 0; i < colors.length; i++) {
        const xPercent = (Math.sin(seed + i * 133.7) + 1) / 2;
        const yPercent = (Math.cos(seed * 0.7 + i * 44.2) + 1) / 2;
        
        const x = xPercent * size.width;
        const y = yPercent * size.height;
        const radius = Math.max(size.width, size.height) * 0.8;
        
        const g = ctx.createRadialGradient(x, y, 0, x, y, radius);
        g.addColorStop(0, colors[i]);
        g.addColorStop(1, 'rgba(255, 255, 255, 0)');
        
        ctx.globalCompositeOperation = 'screen';
        ctx.fillStyle = g;
        ctx.fillRect(0, 0, size.width, size.height);
    }

    ctx.restore();
  }
}

registerPaint('fluent-gradient-mesh', GradientMesh);
